var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',[_c('v-container',{staticClass:"page-container"},[_c('Header'),_c('v-row',{staticClass:"px-5 py-8"},[_c('ProjectList',{attrs:{"projects":_vm.projects,"panelView":true,"publications":_vm.publications}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }